import { Box, IconButton, Toolbar } from '@mui/material'
import MenuIcon from "@mui/icons-material/Menu";
import MuiAppBar from "@mui/material/AppBar";
import logoAscoprel from '../../../../images/ascoprel_horizontal.png'

import { styled } from "@mui/material/styles";

const HeaderBase = ({ open, handleDrawerToggle }) => {

    return (
        <AppBar position="fixed" open={open} sx={{ bgcolor: "white" }}>
            <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <IconButton
                        aria-label="open drawer"
                        onClick={handleDrawerToggle}
                        edge="start"
                        sx={{ mr: 2, ...(open && { display: "none" }) }}
                    >
                        <MenuIcon />
                    </IconButton>
                </Box>
            
                <Box component="div" noValidate align="center">
                    <div
                        style={{
                            width: '80px', // Ajuste o tamanho conforme necessário
                            height: '60px',
                            margin: 'auto', // Centraliza com margem
                            backgroundImage: `url(${logoAscoprel})`,
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                        }}
                    ></div>
                </Box>
            </Toolbar>
        </AppBar>
    )
}

export default HeaderBase

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
    transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));
